/* eslint-disable react/display-name */
import React from 'react';
import styled from 'styled-components';

import { CircularProgress, Text } from '@tapresearch/ui/components';

export const Loading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  font-weight: 400;
  font-size: 16px;
  padding: 50px;
  color: ${(props) => props.color};
`;

export default ({ color = 'blue.500' }) => {
  return (
    <Loading data-testid="loading-indicator">
      <CircularProgress
        size="70px"
        thickness="7px"
        isIndeterminate
        color={color}
      />
      <Text
        color="gray.400"
        my={2}
        textTransform="uppercase"
        letterSpacing="1px"
        fontWeight="semibold"
      >
        Loading
      </Text>
    </Loading>
  );
};
